export default __webpack_public_path__ + "static/media/trust-wallet.123a2360.svg";